var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-pagination',{attrs:{"total":_vm.count,"show-total":function (total, range) { return ("Showing " + (new Intl.NumberFormat(_vm.currency.currency_Formate, {
          maximumSignificantDigits: 3
        }).format(range[0])) + " to " + (new Intl.NumberFormat(
          _vm.currency.currency_Formate,
          {
            maximumSignificantDigits: 3
          }
        ).format(range[1])) + " of " + total + " records"); },"page-size":_vm.pageSize,"current":_vm.currentPage,"default-current":_vm.currentPage,"showTitle":true,"showQuickJumper":true,"showLessItems":true},on:{"change":_vm.changePagination}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }